'use strict'

import React, { useEffect } from 'react'
// @material-ui/core components
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
// import Switch from '@mui/material/Switch'
import Select from '@mui/material/Select'
import Icon from '@mui/material/Icon'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
// import LinearProgress from '@mui/material/LinearProgress'
import CircularProgress from '@mui/material/CircularProgress'
// import FormHelperText from '@mui/material/FormHelperText'
// import FormControlLabel from '@mui/material/FormControlLabel'

// Material Dashboard 2 PRO React components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput'
import MDTypography from 'components/MDTypography'
import MDSnackbar from 'components/MDSnackbar'
// import SelectZeroUno from 'components/ZeroUno/SelectZeroUno'

// zerouno
import authService from 'services/auth.service'

import albumService from 'services/album.service'
import mainService from 'services/image.service'
import uploadService from 'services/upload.service'
import { config } from 'variables/Config.js'
import { useForm, Controller } from 'react-hook-form'
import { useParams, Link, useNavigate } from 'react-router-dom'

export default function ImageForm () {
  const { idObj } = useParams()
  const { idAlbum } = useParams()
  const [obj, setObj] = React.useState({})
  const [albums, setAlbums] = React.useState([])
  const [img, setImg] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [showSnackbar, setShowSnackbar] = React.useState({ sh: false, msg: '', color: 'success' })
  const { register, handleSubmit, formState: { errors }, control, getValues, reset } = useForm(
    {
      defaultValue: {
        albumId: idAlbum
      }
    }
  )
  const navigate = useNavigate()
  const loggedUser = authService.user()

  useEffect(() => {
    fetchObject()
    fetchAlbums()
  }, [])

  useEffect(() => {
    reset({ ...obj })
  }, [obj])

  const fetchObject = () => {
    if (idObj === 'new') {
      setObj({ albumId: '' + idAlbum })
    } else {
      mainService.get(idAlbum, idObj).then(
        (response) => {
          setObj(response.data)
          setImg(response.data.file)
        },
        (error) => {
          setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
        }
      )
    }
  }

  const fetchAlbums = () => {
    albumService.getAll().then(
      (response) => {
        setAlbums(response.data)
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  const onSubmit = (data) => {
    data.file = img
    console.log('data: ', data)
    if (idObj === 'new') {
      addObj(data)
    } else {
      data.id = obj.id
      updateObj(data, obj.id)
    }
  }

  // Add obj
  const addObj = (data) => {
    console.log('album:' + data.albumId)
    mainService.create(data).then(
      (response) => {
        setShowSnackbar({ sh: true, msg: 'operazione effettuata con successo', color: 'success' })
        navigate(`/albums/${data.albumId}/images`)
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  const updateObj = (data, id) => {
    mainService.update(id, data).then(
      (response) => {
        setShowSnackbar({ sh: true, msg: 'operazione effettuata con successo', color: 'success' })
        navigate(`/albums/${data.albumId}/images`)
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  const uploadFile = (files) => {
    const file = files[0]
    if (file) {
      if (file.size <= 50 * 1024000) {
        setLoading(true)
        const formData = new FormData()
        formData.append('file', file)
        uploadService.uploadOne(formData).then(
          (response) => {
            setLoading(false)
            const image = response.data.filename
            setImg(image)
          },
          (error) => {
            setLoading(false)
            setShowSnackbar({ sh: true, msg: 'errore upload file', color: 'error' })
          }
        )
      } else {
        setShowSnackbar({ sh: true, msg: 'file troppo grande', color: 'error' })
      }
    }
  }

  const removeFile = () => {
    const formData = new FormData()
    formData.delete('file')
    setImg('')
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={8}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Card>
                <MDBox display='flex'>
                  <MDBox
                    display='flex'
                    justifyContent='center'
                    alignItems='center'
                    width='4rem'
                    height='4rem'
                    variant='gradient'
                    bgColor='info'
                    color='white'
                    shadow='md'
                    borderRadius='xl'
                    ml={3}
                    mt={-2}
                  >
                    <Icon fontSize='medium' color='inherit'>
                      photo
                    </Icon>
                  </MDBox>
                  <MDTypography variant='h5' sx={{ mt: 2, mb: 1, ml: 2 }}>
                    Immagine
                  </MDTypography>
                </MDBox>
                <MDBox p={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                      <MDInput
                        fullWidth
                        type='text'
                        autoFocus
                        required
                        label='titolo'
                        error={!!(errors.title)}
                        {...register('title', { required: true })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      {obj.albumId && (
                        <FormControl
                          fullWidth
                          required
                          error={!!errors.albumId}
                        >
                          <InputLabel id='lblAlbum'>Album</InputLabel>
                          <Select
                            labelId='lblAlbum'
                            sx={{ p: 1.5 }}
                            defaultValue={obj.albumId}
                            {...register('albumId', { required: true })}
                          >
                            <MenuItem key='0' value=''>seleziona un album</MenuItem>
                            {albums && albums.map((item) =>
                              <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                            )}
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <MDInput
                        fullWidth
                        type='text'
                        required={false}
                        label='descrizione'
                        error={!!(errors.description)}
                        {...register('description', { required: false })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <MDInput
                        fullWidth
                        type='text'
                        required={false}
                        label='tags'
                        error={!!(errors.tags)}
                        {...register('tags', { required: false })}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={6} sm={6} md={12}>
                    <Stack>

                      {(img === null || img === undefined || img === '') && (
                        <label htmlFor='contained-button-file'>
                          <MDInput
                            accept='image/*'
                            id='contained-button-file'
                            type='file'
                            sx={{ display: 'none' }}
                            onChange={(target) => uploadFile(target.target.files)}
                          />
                          <MDButton
                            variant='gradient'
                            color='info'
                            component='span'
                            style={{ marginTop: '30px' }}
                          >
                            Upload immagine (jpg, png) max 50Mb
                          </MDButton>
                        </label>
                      )}
                      {loading && <CircularProgress color='primary' sx={{ m: 2 }} />}
                      {img && (
                        <img
                          src={config.SERVER_URL + '/download/min_' + img}
                          alt='immagine'
                          style={{ padding: '20px' }}
                        />
                      )}
                      {img && authService.isAdmin() && (
                        <MDButton color='error' onClick={() => removeFile()}>
                          elimina
                        </MDButton>
                      )}
                    </Stack>

                  </Grid>
                </MDBox>
                <MDBox p={2}>
                  <MDButton
                    variant='gradient' color='secondary' component={Link} to={`/albums/${idAlbum}/images`} sx={{ mr: 1 }}
                  >
                    vai all'album
                  </MDButton>
                  <MDButton
                    variant='gradient' color='secondary' component={Link} to='/dashboard/main' sx={{ mr: 1 }}
                  >
                    vai alla dashboard
                  </MDButton>
                  {authService.isAdmin() &&
                    <MDButton type='submit' variant='gradient' color='success'>
                      Salva
                    </MDButton>}
                </MDBox>
              </Card>
            </form>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Card>
              <MDBox p={2}>
                <MDTypography variant='h6'>Immagine</MDTypography>

                <MDTypography variant='h4'>{obj.title}</MDTypography>
                <Stack spacing={2}>
                  {idObj !== 'new' &&
                    <MDButton
                      color='primary'
                      size='small'
                      href={`${config.SERVER_URL}/download/${obj.file}`}
                      target='_blank'
                      mb={2}
                    >
                      download originale
                    </MDButton>}
                  {idObj !== 'new' &&
                    <MDButton
                      color='primary'
                      size='small'
                      href={`${config.SERVER_URL}/download/min_${obj.file}`}
                      target='_blank'
                    >
                      download miniatura
                    </MDButton>}
                </Stack>

              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <MDSnackbar
        color={showSnackbar.color}
        icon='notifications'
        title='Notifica'
        content={showSnackbar.msg}
        dateTime='adesso'
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: '', color: 'info' })}
      />
    </DashboardLayout>
  )
}
